import { Link } from "react-router-dom";
import { usePageContent } from "@/context/PageContentContext";
import Seo from "@/components/site/Seo";
import { Img } from "@/assets";

export default function Company() {
  const c = usePageContent();
  return (
    <>
      <Seo />
      <section className="gp-page-hero" data-testid="company-hero">
        <div className="gp-page-hero__img" aria-hidden="true">
          <Img id="port-aerial-dawn" alt="" />
        </div>
        <div className="gp-wrap gp-page-hero__inner">
          <div className="gp-eyebrow"><span className="gp-eyebrow-num">01</span><span className="gp-eyebrow-sep" /> Our Company</div>
          <h1 className="gp-h1 gp-page-hero__title">A trading company with two markets and one standard.</h1>
          <p className="gp-page-hero__lede" data-testid="company-intro">{c["company.intro"]}</p>
        </div>
      </section>

      <section className="gp-section gp-on-white" data-testid="company-values">
        <div className="gp-wrap">
          <div className="gp-eyebrow" style={{ color: "var(--gp-ink)" }}>
            <span className="gp-eyebrow-num">02 </span><span className="gp-eyebrow-sep" /> Our values
          </div>
          <h2 className="gp-h2" style={{ maxWidth: "20ch", marginBottom: 64 }}>The way we work is the reason we're trusted.</h2>
          <div className="gp-values">
            <div className="gp-value"><div className="gp-value__num">01</div><div className="gp-value__title">Transparency</div><p className="gp-value__body">Clear terms, clear communication. Every party knows where they stand.</p></div>
            <div className="gp-value"><div className="gp-value__num">02</div><div className="gp-value__title">Consistency</div><p className="gp-value__body">Reliable execution across cycles.</p></div>
            <div className="gp-value"><div className="gp-value__num">03</div><div className="gp-value__title">Efficiency</div><p className="gp-value__body">Lean processes and disciplined logistics.</p></div>
            <div className="gp-value"><div className="gp-value__num">04</div><div className="gp-value__title">Shared value</div><p className="gp-value__body">Outcomes designed for customers, partners and stakeholders together.</p></div>
          </div>
        </div>
      </section>

      <section className="gp-section gp-on-navy" data-testid="company-vision-mission">
        <div className="gp-wrap">
          <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 64 }}>
            <div>
              <div className="gp-eyebrow"><span className="gp-eyebrow-num">03 </span><span className="gp-eyebrow-sep" /> Vision</div>
              <p className="gp-quote" data-testid="company-vision">{c["company.vision"]}</p>
            </div>
            <hr className="gp-rule" />
            <div>
              <div className="gp-eyebrow"><span className="gp-eyebrow-num">04 </span><span className="gp-eyebrow-sep" /> Mission</div>
              <p className="gp-quote gp-quote--sub" data-testid="company-mission">{c["company.mission"]}</p>
            </div>
          </div>
          <div style={{ marginTop: 80, display: "flex", flexWrap: "wrap", gap: 16 }}>
            <Link to="/divisions" className="gp-btn" data-testid="company-cta-divisions">See our divisions <span className="gp-arrow">→</span></Link>
            <Link to="/contact" className="gp-link" data-testid="company-cta-contact">Contact the company <span className="gp-arrow">→</span></Link>
          </div>
        </div>
      </section>
      <section className="gp-section gp-on-white" data-testid="company-international">
        <div className="gp-wrap">
          <div className="gp-eyebrow" style={{ color: "var(--gp-ink)" }}>
            <span className="gp-eyebrow-num">05 </span><span className="gp-eyebrow-sep" /> An international business
          </div>
          <h2 className="gp-h2" style={{ maxWidth: "22ch", marginBottom: 24 }}>An international business built around relationships.</h2>
          <p className="gp-body" style={{ maxWidth: "60ch" }} data-testid="company-international-body">
            Gold Petroleum brings together a focus on petroleum products and precious metals with
            relationships in shipping, storage and refining. The company's stated approach centres
            on transparency, consistency, efficiency and shared value.
          </p>
        </div>
      </section>

      <section className="gp-section gp-on-white" data-testid="company-how-to-read">
        <div className="gp-wrap">
          <div className="gp-eyebrow" style={{ color: "var(--gp-ink)" }}>
            <span className="gp-eyebrow-num">06 </span><span className="gp-eyebrow-sep" /> How to read this page
          </div>
          <ul className="gp-hint-list" data-testid="company-hint-list">
            <li>Gold Petroleum FZ LLC is UAE-registered. Leadership may operate across UAE and Canada; registration and leadership location are distinct.</li>
            <li>Regions of ambition (Middle East, Africa, Asia) reflect where the company aims to build business. Confirmed operating countries will be added as they are approved.</li>
            <li>Partner relationships in shipping, storage and refining are documented, not company-owned. Company values guide communication; they are not a substitute for independent performance evidence.</li>
          </ul>
        </div>
      </section>
    </>
  );
}
